// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';             // Votre CSS Tailwind

// Attention à la casse et au nom exact des fichiers
import Pair    from './pages/Pair';
import Devices from './pages/Devices';
import Devicestpe from './pages/Devicestpe';
import Transaction   from './pages/Transation';
import Dashboard   from './pages/Dashboard';
import Regit   from './pages/Regit';
import Login   from './pages/login';
import Users   from './pages/Users';
import Magasins   from './pages/Magasins';
import Configuration from './pages/Configuration';
import Tags from './pages/Tags';



function App() {
  return (
    <Router>
      <Routes>
        {/* Redirige "/" vers "/devices" */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Vos pages */}
        <Route path="/devices" element={<Devices />} />
        <Route path="/devicestpe" element={<Devicestpe />} />
        <Route path="/transaction" element={<Transaction />} />
         <Route path="/dashboard" element={<Dashboard  />} />
         <Route path="/regit" element={<Regit  />} />
        <Route path="/pair"    element={<Pair />}    />
        <Route path="/login"    element={<Login />}    />
         <Route path="/users"    element={<Users />}    />
           <Route path="/magasins"    element={<Magasins />}    />
           <Route path="/configuration" element={<Configuration />} />
           <Route path="/tags" element={<Tags />} />
      

        {/* 404 */}
        <Route
          path="*"
          element={
            <div className="flex items-center justify-center h-screen">
              <h2 className="text-2xl text-red-500">Page non trouvée</h2>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;